import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export enum ToastType {
  Success = 'Success',
  Error = 'Error',
  Info = 'Info',
}
export const sendToast = (message: string, type: ToastType) => {
  const options: ToastOptions = {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,    
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: type === ToastType.Success ? {backgroundColor: '#36866E'} : 
           type === ToastType.Error ? {backgroundColor: '#A74141'} : {backgroundColor: '#7D7D7D'}
   };
  toast.dismiss();
  if (type === ToastType.Success) {
    toast.success(message, options);
  } else if (type === ToastType.Error) {
    toast.error(message, options);
  } else if (type === ToastType.Info) {
    toast.info(message, options);
  }
  return { type: "@@toast", payload: { message, type } };
}
